import axios from "axios";
import { cdnUrl, cdnUrlV2 } from "./url";

export const uploader = async (files, type = "image", folder = "gallery") => {
  try {
    const fileList = Array.isArray(files) ? files : [files];
    const uploadedIds = [];

    for (const file of fileList) {
      const rawFile = file?.originFileObj || file;
      if (!rawFile) continue;

      const formData = new FormData();
      formData.append(type, rawFile);

      const res = await axios.post(
        `${cdnUrlV2}/upload/${type}/${folder}`,
        formData
      );
      if (res?.data?.data?.file?.id) {
        uploadedIds.push(res.data.data.file.id);
      }
    }

    return Array.isArray(files) ? uploadedIds : (uploadedIds[0] || null);
  } catch (error) {
    console.error("Uploader failed:", error);
    return Array.isArray(files) ? [] : null;
  }
};


/**
 * Uploads a file to the CDN.
 * @param {File} file - The file to upload.
 * @param {string} folder - The folder to upload the file to (e.g., "supportticket").
 * @param {function} afterAsync - Callback function called with the file result or null.
 * @returns {Promise<string|null>} - The file name/path on the CDN or null on failure.
 */
export const uploadToCdn = async (file, folder = "supportticket", afterAsync) => {
  try {
    let fileData = new FormData();
    fileData.append("file", file);
    let res = await axios.post(
      `${cdnUrl}/upload/file/${folder}`,
      fileData,
    );
    const result = res?.data?.result?.file || null;
    if (afterAsync) {
      afterAsync(result);
    }
    return result;
  } catch (error) {
    console.error("File upload failed:", error);
    if (afterAsync) {
      afterAsync(null);
    }
    return null;
  }
};
